import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import './index.css';

export interface accordiaType {
  eventKey?: any;
  header: any;
  children: any;
  activeIndex?:any;
  handleActionHeaderOpen?: () => void;
};

const AccordionComponent = ({ eventKey, header, children, activeIndex, handleActionHeaderOpen}: accordiaType) => {

  return (
    <Accordion defaultActiveKey={null} activeKey={activeIndex}>
      <Accordion.Item eventKey={eventKey} className='header_accordian_item'>
          <Accordion.Header className='header_accordian' onClick={() => handleActionHeaderOpen?.()}>
          {header}
          </Accordion.Header>
        <Accordion.Body>
          {children}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}

export default AccordionComponent;
